import {OutsideClickDirective} from "../utils/directives/outside-click.directive";
import {OpportunitiesController} from "./route/opportunitiesController";
import {OpportunityList} from "./component/opportunityList/opportunityList";
import {CustomerLoanParameters} from "./component/customerLoanParameters/customerLoanParameters";
import {LqbPricerLoanParameters} from "./component/lqbPricerParameters/lqbPricerLoanParameters";

import {EppraisalParameters} from "./component/eppraisalParameters/EppraisalParameters";
import {OpportunityItem} from "./component/opportunity/OpportunityItem";
import {ActionsTooltips} from "./component/opportunityActionsTooltips/ActionsTooltips";
import {SavingsNotification} from "./component/notifications/savingsNotification/savingsNotification";
import {RateNotification} from "./component/notifications/rateNotification/RateNotification";
import {EquityNotification} from "./component/notifications/equityNotifications/EquityNotification";
import {
    RateTermRefinanceNotification
} from "./component/notifications/equityNotifications/rateTermRefinance/RateTermRefinanceNotification";
import {
    CashOutNotification
} from "./component/notifications/equityNotifications/cashOutNotification/CashOutNotification";
import OpportunitiesModuleConfiguration from "./opportunitiesModuleConfiguration";
import {TriggerLeadsNotification} from "./component/notifications/triggerLeadsNotification/triggerLeadsNotification";
import {TriggerLeadsParameters} from "./component/triggerLeadsParameters/triggerLeadsParameters";


OpportunitiesModuleConfiguration.createNewModule()
    .component('savingsNotification', SavingsNotification.instance)
    .component('triggerLeadsNotification', TriggerLeadsNotification.instance)
    .component('eppraisalParameters', EppraisalParameters.instance)
    .component('rateNotification', RateNotification.instance)
    .component('equityNotification', EquityNotification.instance)
    .component('rateTermRefinanceNotification', RateTermRefinanceNotification.instance)
    .component('cashOutNotification', CashOutNotification.instance)
    .component('customerLoanParameters', CustomerLoanParameters.instance)
    .component('opportunitiesList', OpportunityList.instance)
    .component('pricerParameters', LqbPricerLoanParameters.instance)
    .component('triggerLeadsParameters', TriggerLeadsParameters.instance)
    .component('opportunityItem', OpportunityItem.instance)
    .component('actionsTooltips', ActionsTooltips.instance)
    .controller('opportunitiesController', OpportunitiesController.instance)
    .directive('clickOutsideDirective', OutsideClickDirective);